import { TextField, TextFieldProps } from "@mui/material";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

type RHFTextFieldProps<T extends FieldValues> = {
  name: Path<T>;
  control?: Control<T>;
} & TextFieldProps;

export function RHFTextField<T extends FieldValues>({
  name,
  control,
  ...textFieldProps
}: RHFTextFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...textFieldProps}
          fullWidth
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
